/**
 * SSR-safety helpers.
 *
 * These exist so component render paths (including lazy useState initializers,
 * which DO run on the server) can touch browser storage without crashing during
 * server-side rendering.
 */

export const isBrowser = typeof window !== 'undefined';

export function safeLocalGet(key: string): string | null {
  if (!isBrowser) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalSet(key: string, value: string): void {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode, quota) — non-fatal */
  }
}

export function safeSessionGet(key: string): string | null {
  if (!isBrowser) return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeJsonParse<T>(raw: string | null, fallback: T): T {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}
